import { useEffect, useState } from 'react';
import http from 'hub-http/clients/apiClient';
import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEADLINE_DATE = new Date('2025-11-24');
const BrandMigrationAlert = () => {
  const [showAlert, setShowAlert] = useState(false);
  useEffect(() => {
    http.get('branding/v1/brand-and-site-settings-diffs').then(response => {
      if (response !== null && response !== void 0 && response.count && response.count > 0) {
        setShowAlert(true);
      }
    }).catch(error => {
      console.error(error);
    });
  }, []);
  const legacyBrandSettingsUrl = `${Routes.logoSettings('')}&resolveConflicts=true`;
  const date = /*#__PURE__*/_jsx(FormattedDateTime, {
    value: DEADLINE_DATE,
    format: "medium-full-date",
    type: "utc"
  });
  return showAlert ? /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-recessed",
    paddingInline: "500",
    paddingBlockStart: "400",
    children: /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "components.messages.brandMigrationAlert.title",
        options: {
          date
        }
      }),
      type: "warning",
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "components.messages.brandMigrationAlert.message",
          options: {
            date
          }
        }), /*#__PURE__*/_jsx(Button, {
          external: true,
          size: "sm",
          use: "primary",
          href: legacyBrandSettingsUrl,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "components.messages.brandMigrationAlert.reviewAndConfirm"
          })
        })]
      })
    })
  }) : null;
};
export default BrandMigrationAlert;